import React from 'react';
import { Row, Col } from '@qc/particle/lib/components/grid';
import styled from 'styled-components';
import Typography from '@qc/particle/lib/components/typography';

const {Paragraph} = Typography;

const QCPanelStyles = styled.div`
    position: absolute;
    top: 0;
    left: 0;
`
const AuthContainer = styled.div`
        height: 100%;
        min-height: 600px;
        width: 100%;
        display: grid;
        align-items: center;
        padding-top: 10px;

        .particle-row {
          width: 100%;
        }

        .info-container {
            display: flex;
            height: 100%;
            min-height: 600px;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            animation-name: panel_text;
            animation-duration: 2s;

            margin: 20px auto 0px;
            max-width: 400px;
            font-size: 16px;

            .headline {
              font-family: proxima-nova, NeuzeitSLTStd-BookHeavy, Arial, "sans-serif";
              font-size: 2em;
              line-height: normal;
              font-weight: 800;
              margin-top: 30px;
              margin-bottom: 10px;
              letter-spacing: -0.5px;
            }
            .subheadline {
              line-height: normal;
              font-family: proxima-nova, NeuzeitSLTStd-Book, Arial, "sans-serif";
              font-size: 1.5em;
              font-weight: 600;
            }

            h3 {
              margin-top: 30px;
              font-weight: bold;
            }
            li {
              list-style-type: disc;
            }
        }
`

const QuantcastLogo = styled.div`
        background-position: center;
        background-size: contain;
        background-image: url("https://static.quantcast.com/images/quantcast-logo-black.svg");
        background-repeat: no-repeat;
        position: relative;
        z-index: 1;
        min-height: 26px;
        width: 148px;
`

const QCPanel = () => {
    return (
      <QCPanelStyles>
        <svg
          id="fan1"
          width="236" preserveAspectRatio="none" height="829" viewBox="0 0 236 829" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0.987457L235.863 166.506V679.612L0 828.579V0.987457Z" fill="#204AED"/>
        </svg>
        <svg
          id="fan2"
          width="137" preserveAspectRatio="none" height="829" viewBox="0 0 137 829" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.34436 0.987457L136.897 166.506V679.612L0.34436 828.579V0.987457Z" fill="#76FB77"/>
        </svg>
        <svg
          id="fan3"
          width="54" preserveAspectRatio="none" viewBox="0 0 54 829" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.206573 0.987457L54 166.506V679.612L0.206573 828.579V0.987457Z" fill="#E7FE54"/>
        </svg>
      </QCPanelStyles>
    )
}

const QCPanelContainer = ({showMarketingMessage, isSelfServeAdvertise, children}) => {
    return (
        <AuthContainer>
          <Row justify="center" style={{paddingBottom: '20px'}}>
            {showMarketingMessage && (!isSelfServeAdvertise) && (
              <Col xs={0} md={0} xl={12}>
                <div className="info-container">
                  <QuantcastLogo />
                  <h1 className="headline">Free access to real-time audience insights.</h1>
                  <span className="subheadline">Get started with Quantcast Measure today.</span>
                  <h3>Features</h3>
                  <Paragraph>
                    <ul>
                      <li>
                        <p style={{fontSize: "18px"}}>Consumer first, consent driven.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Audience psychographics at your fingertips.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Simple and intuitive interface.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Easy implementation.</p>
                      </li>
                    </ul>
                  </Paragraph>
                </div>
              </Col>
            )}
            {showMarketingMessage && (!!isSelfServeAdvertise) && (
              <Col xs={0} md={0} xl={12}>
                <div className="info-container">
                  <QuantcastLogo />
                  <h1 className="headline">Free access to the leading platform for measurable outcomes.</h1>
                  <span className="subheadline">Get started with Quantcast Advertise today.</span>
                  <h3>Features</h3>
                  <Paragraph>
                    <ul>
                      <li>
                        <p style={{fontSize: "18px"}}>Multiple service tiers.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Flexible payment options.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Intuitive interface built for everyone.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Designed with privacy in mind.</p>
                      </li>
                      <li>
                        <p style={{fontSize: "18px"}}>Omnichannel activation.</p>
                      </li>
                    </ul>
                  </Paragraph>
                </div>
              </Col>
            )}
            <Col
              xs={24}
              md={showMarketingMessage ? 12 : 24}
              xl={showMarketingMessage ? 12 : 24}
            >
                {children}
            </Col>
          </Row>
        </AuthContainer>
    )
}

export default QCPanelContainer;